import React, { useState } from 'react';
import { Box, FormControl, OutlinedInput, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useDebouncedCallback } from 'use-debounce';
import { searchInput } from '../../../../shared/styleClasses';
import SimpleSelect from './SimpleSelect';

interface TokenUsageSearchBarProps {
  onSearchChange: (value: string) => void;
  onDateFilterChange: (value: string) => void;
  dateFilter: string;
  placeholder?: string;
}

const DATE_FILTER_OPTIONS = [
  { value: 'all_time', label: 'All Time' },
  { value: 'current_month', label: 'Current Month' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'last_half_year', label: 'Last 6 Months' },
  { value: 'last_year', label: 'Last Year' }
];

const TokenUsageSearchBar: React.FC<TokenUsageSearchBarProps> = ({
  onSearchChange,
  onDateFilterChange,
  dateFilter,
  placeholder = 'Search by candidate name'
}) => {
  const [searchValue, setSearchValue] = useState('');

  const debouncedSearch = useDebouncedCallback((value: string) => {
    onSearchChange(value);
  }, 600);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    setSearchValue(value);

    debouncedSearch(value);
  };

  const handleClearSearch = () => {
    setSearchValue('');
    onSearchChange('');
  };

  const handleDateFilterChange = (value: string) => {
    onDateFilterChange(value);
  };

  const searchInputAdornment = () => {
    if (searchValue) {
      return (
        <InputAdornment
          sx={{ padding: '0px 0px 0px 14px', cursor: 'pointer' }}
          position="start"
          onClick={handleClearSearch}
        >
          <CloseIcon sx={{ marginBottom: '3.5px' }} />
        </InputAdornment>
      );
    } else {
      return (
        <InputAdornment sx={{ padding: '0px 0px 0px 14px' }} position="start">
          <SearchIcon />
        </InputAdornment>
      );
    }
  };

  const filtersRowStyles = {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    margin: '30px 0 30px 0',
    columnGap: '17px'
  };

  return (
    <Box sx={filtersRowStyles}>
      <Box sx={{ flex: 1, position: 'relative' }}>
        <FormControl fullWidth>
          <OutlinedInput
            id="search-box-token-usages"
            sx={searchInput}
            placeholder={placeholder}
            value={searchValue}
            onChange={handleSearchChange}
            startAdornment={searchInputAdornment()}
          />
        </FormControl>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <Box
          sx={{
            color: '#838383',
            fontSize: '14px',
            fontFamily: 'Source Sans Pro, sans-serif',
            fontWeight: 500
          }}
        >
          Period
        </Box>
        <SimpleSelect
          id="date-filter-token-usages"
          value={dateFilter}
          onChange={handleDateFilterChange}
          options={DATE_FILTER_OPTIONS}
          height="70px"
          width="200px"
        />
      </Box>
    </Box>
  );
};

export default TokenUsageSearchBar;
